import { render, staticRenderFns } from "./NavbarLink.vue?vue&type=template&id=28bf5c80&scoped=true"
import script from "./NavbarLink.vue?vue&type=script&lang=js"
export * from "./NavbarLink.vue?vue&type=script&lang=js"
import style0 from "./NavbarLink.vue?vue&type=style&index=0&id=28bf5c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf5c80",
  null
  
)

export default component.exports